// extracted by mini-css-extract-plugin
module.exports = {"unverifiedContentContainer":"_2SorXPcu","suggestedFieldsContainer":"_1rOS2Uhs","unverifiedImage":"_1tVoRgo5","suggestedField":"_3VnXb5bE","actions":"_2TZ8b9X2","noPadding":"_9wCJd0rF","inputField":"_1KSU81Sl","saveButton":"_2nT-JOdM","containerFlexColumn":"KVCgVFu0","containerFlexRow":"_1x8Ns-Am","basicInfoTop":"_2bWxxGht","inputError":"PGeDALEa"};
    if(module.hot) {
      // 1746735801314
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  